"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = Text;
exports.Strong = Strong;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = require("clsx");
// Operator-density default: 14px body. Color from design-system neutral scale.
// `Strong` lifts to neutral-900 + medium weight.
function Text(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("p", Object.assign({ "data-slot": 'text' }, props, { className: (0, clsx_1.clsx)(className, 'text-sm leading-relaxed text-neutral-700') }));
}
function Strong(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("strong", Object.assign({}, props, { className: (0, clsx_1.clsx)(className, 'font-medium text-neutral-900') }));
}
